import { render, staticRenderFns } from "./MamTradeHistory.vue?vue&type=template&id=150fc262&scoped=true"
import script from "./MamTradeHistory.vue?vue&type=script&lang=js"
export * from "./MamTradeHistory.vue?vue&type=script&lang=js"
import style0 from "./MamTradeHistory.vue?vue&type=style&index=0&id=150fc262&prod&lang=scss&scoped=true"
import style1 from "./MamTradeHistory.vue?vue&type=style&index=1&id=150fc262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150fc262",
  null
  
)

export default component.exports